import React from 'react'
import "./navbar.css"
import {
    Container,
    Nav,
    Navbar,
    NavDropdown
} from 'react-bootstrap'
import {
    useLocation,
} from "react-router-dom";
import Logo from '../../assets/images/logos/pstLogo.png'


const customClass = "link";
const NavbarComponent = () => {
    let location = useLocation();
    console.log("Location", location)
    return (
        <Navbar bg="light" expand="lg" className='navbar' sticky='top'>
            <Container>
                <Navbar.Brand href="/">
                    <img src={Logo} alt="" className='logo' />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav activeKey={location.pathname} className="navlinks ms-auto">
                        <Nav.Link href="/" bsPrefix={customClass}>Home</Nav.Link>
                        <Nav.Link href="/principles" bsPrefix={customClass} >Principles</Nav.Link>
                        <Nav.Link href="/services" bsPrefix={customClass} >Services</Nav.Link>
                        <NavDropdown title="About Us" id="basic-nav-dropdown"  bsPrefix={customClass}>
                            <NavDropdown.Item href="/aboutus/history" className='dropItemsStyle' >History</NavDropdown.Item>
                            <NavDropdown.Item href="/aboutus/bio" className='dropItemsStyle' >Company Philosophy</NavDropdown.Item>
                        </NavDropdown>
                        <Nav.Link href="/contact" bsPrefix={customClass} >Contact Us</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}
export default NavbarComponent